import { useMemo } from 'react';

import { InventoryProvider, MappingCollections } from '@scaleaq/sitecontrol-lib';

export const useClassInventoryProviderPair = () => {
  const providerClassPair = MappingCollections.inventoryProviderClassPair;
  const classInventoryProviderPair = useMemo(
    () =>
      Object.entries(providerClassPair).reduce(
        (acc, [key, value]) => ({
          ...acc,
          [value]: key as InventoryProvider,
        }),
        {} as Record<string, InventoryProvider>
      ),
    [providerClassPair]
  );

  return { classInventoryProviderPair };
};
